import { LanguageModel } from '../models/language.model';

import { getActualLan } from './get-actual-lan';

export function getActualLanguage(languages: LanguageModel[]): LanguageModel {
  const langPrefix = getActualLan();
  if (langPrefix) {
    return languages.find((lang) => lang.prefix === langPrefix) as LanguageModel;
  } else {
    return languages[0];
  }
}
